import { withTheme } from 'styled-components';
import { oneOfType, node, string, func } from 'prop-types';

import SCaption from './styles';

const Caption = ({ children }) => {
  return <SCaption>{children}</SCaption>;
};

Caption.propTypes = {
  children: oneOfType([node, string, func]).isRequired,
};

export default withTheme(Caption);
